import Cookies from 'js-cookie';
import { encryptData } from '../common/utils';

const getLocalRefreshToken = () => {
    return Cookies.get('refresh_token');
};

const getLocalAccessToken = () => {
    return Cookies.get('access_token');
};

const updateLocalAccessToken = (token) => {
    Cookies.set('access_token', token, { secure: true, sameSite: 'Strict', path: '/' });
};

const getUser = () => {
    const user = Cookies.get('user');
    return user ? JSON.parse(user) : null;
};

const setUser = (user) => {

    if (!user || !Array.isArray(user.permissions)) {
        console.error("<<< [TokenService.setUser] ERROR: 'permissions' key is missing or not an array in received data!");
        user = { ...user, permissions: [] }; 
    }
    let tipo_usuario = '';
    

    if (user['restricoes'] && user['restricoes'].length > 0 && !user.is_superuser) {
        tipo_usuario = user['restricoes'][0]['tipo_usuario'];
    }

    const dados_user = {
        'email': user.email,
        'username': user.username,
        'name': user.first_name,
        'last_name': user.last_name,
    };

    const dados_outros = {
        'groups': user.groups,
        'is_staff': user.is_staff,
        'is_superuser': user.is_superuser,
        'acesso_liberado': user.acesso_liberado !== undefined ? user.acesso_liberado : (tipo_usuario && tipo_usuario !== 'administrador' ? false : (user.is_superuser || user.is_staff)),
        'tipo_usuario': tipo_usuario,
        'operador_id': '',
        'prestador_id': user.prestador_id || '',
        'gestor_id': '',
        'prestador_categoria': user.prestador_categoria || '',
        'ambiente_cliente_id': user.ambiente_cliente_id || '',
        'ambiente_programa_id': user.ambiente_programa_id || '',
        'ambiente_carteira_id': '',
    };

    const dados_prog = {
        'ambiente_programa_uuid': ''
    }

    const permissionsUnicas = [...new Set(user.permissions || [])];

    try {
        encryptData('o', dados_outros);
        encryptData('r', (user.is_superuser) ? [] : user.restricoes || []); // Adiciona fallback
        encryptData('p', permissionsUnicas, 'localStorage');
        encryptData('prog', dados_prog);
    } catch (e) {
        console.error("<<< [TokenService.setUser] CRITICAL ERROR during encryptData:", e);
    }

    // Armazena dados_user em cookie
    const expires = 1; // Expira em 1 dia
    Cookies.set('access_token', user.access, { expires, secure: true, sameSite: 'Strict', path: '/' });
    Cookies.set('refresh_token', user.refresh, { expires, secure: true, sameSite: 'Strict', path: '/' });
    Cookies.set('user', JSON.stringify(dados_user), { expires, secure: true, sameSite: 'Strict', path: '/' });
};

const removeUser = () => {
    // Preserva o redirect antes de limpar
    const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin");
    
    localStorage.clear();
    sessionStorage.clear();

    // Restaura o redirect após limpar
    if (redirectAfterLogin) {
        sessionStorage.setItem("redirectAfterLogin", redirectAfterLogin);
    }

    Cookies.remove('access_token', { path: '/' });
    Cookies.remove('refresh_token', { path: '/' });
    Cookies.remove('user', { path: '/' });
    Cookies.remove('o', { path: '/' });
    Cookies.remove('r', { path: '/' });
    Cookies.remove('p', { path: '/' });
    Cookies.remove('prog', { path: '/' });
    Cookies.remove('p_login', { path: '/' });

};

const TokenService = {
    getLocalRefreshToken,
    getLocalAccessToken,
    updateLocalAccessToken,
    getUser,
    setUser,
    removeUser,
};

export default TokenService;
